import { onCleanup } from 'solid-js'

/* 4px col-resize grip, same idea as code search's <splitter>: it doesn't own the
   width, it just reports the new one and lets the parent hold the state */
export function Splitter(props: { onResize: (width: number) => void, min?: number, max?: number }) {
  function onMouseDown(e: MouseEvent) {
    e.preventDefault()

    const onMove = (move: MouseEvent) => {
      const width = Math.min(props.max ?? 640, Math.max(props.min ?? 160, move.clientX))
      props.onResize(width)
    }
    const onUp = () => {
      window.removeEventListener('mousemove', onMove)
      window.removeEventListener('mouseup', onUp)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }

    document.body.style.cursor = 'col-resize'
    document.body.style.userSelect = 'none'
    window.addEventListener('mousemove', onMove)
    window.addEventListener('mouseup', onUp)
    onCleanup(onUp)
  }

  return (
    <div
      class="w-1 shrink-0 cursor-col-resize bg-border transition-colors hover:bg-ring"
      onMouseDown={onMouseDown}
    />
  )
}
